import { render, staticRenderFns } from "./CustomInvitationModal.vue?vue&type=template&id=ba0a64e4&scoped=true&"
import script from "./CustomInvitationModal.vue?vue&type=script&lang=js&"
export * from "./CustomInvitationModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomInvitationModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomInvitationModal.vue?vue&type=style&index=1&id=ba0a64e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0a64e4",
  null
  
)

export default component.exports